import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/play.png';
import _imports_1 from '@/assets/componentImg/ask/comment.png';
import _imports_2 from '@/assets/componentImg/ask/liked.png';
import _imports_3 from '@/assets/componentImg/ask/like.png';

const _withScopeId = n => (_pushScopeId("data-v-1af58a2f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "cell"
};
const _hoisted_2 = {
  key: 1,
  class: "video-wrap"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "play-btn",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_4 = {
  class: "bottom-wrap"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  alt: ""
};
import ContentWrap from '@/components/ask/content-wrap.vue';
import ImageWrap from '@/components/channel/image-wrap.vue';
import composition from '@/composition';
import LikeBtn from '@/components/common/like-btn.vue';
export default {
  props: {
    item: Object,
    help: Boolean
  },

  setup(__props) {
    const props = __props;
    const {
      openWebPage
    } = composition();

    const openDetail = () => {
      if (props.help) {
        // 帮办
        return;
      }

      openWebPage('moment.html', props.item.id, props.item);
    };

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        onClick: openDetail
      }, [_createVNode(ContentWrap, {
        item: __props.item,
        type: "-1"
      }, null, 8, ["item"]), __props.item.images && __props.item.images.length > 0 ? (_openBlock(), _createBlock(ImageWrap, {
        key: 0,
        images: __props.item.images
      }, null, 8, ["images"])) : _createCommentVNode("", true), __props.item.videos && __props.item.videos.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_image, {
        class: "video-img",
        src: __props.item.videos[0].coverPath,
        fit: "cover"
      }, null, 8, ["src"]), _hoisted_3])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "btn",
        onClick: openDetail
      }, [_hoisted_5, _createTextVNode(" " + _toDisplayString(__props.item.commentCount), 1)]), _createVNode(LikeBtn, {
        class: "btn",
        item: __props.item
      }, {
        main: _withCtx(({
          record
        }) => [record.loveState ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7)), _createElementVNode("span", {
          style: _normalizeStyle({
            color: record.loveState ? '#FF2D3C' : '#666'
          })
        }, _toDisplayString(record.loveCount == 0 ? '点赞' : record.loveCount), 5)]),
        _: 1
      }, 8, ["item"])])]);
    };
  }

};